import CommonUiModel from "../common/commonUiModel";

const Lookup = new CommonUiModel({
    title: "Lookup",
    linkColumn: "DisplayValue",
    permissions: { add: false, edit: false, delete: false },
    searchParamKey: 'LookupType',
    columns: [
        {
            field: 'DisplayValue',
            label: 'Lookup Value',
            max: 64,
            required: true
        },
        {
            field: 'LookupTypeId',
            label: 'Lookup Type',
            type: 'select',
            width: 200,
            required: true,
            lookup: 'LookupType'
        },
        {
            field: 'CustomStringValue',
            label: 'Custom String Value',
            max: 64,
            min: 0
        },
        {
            field: 'SortOrder',
            label: 'Sort Order',
            type: 'number',
            width: 200
        },
        {
            field: 'Active',
            label: 'Active',
            width: 80,
            type: 'boolean',
            defaultValue: true
        },
        {
            field: 'IsDefault',
            label: 'Is Default',
            width: 150,
            type: 'boolean',
            defaultValue: false
        },
        {
            field: 'ReferenceValue',
            label: 'Ref Value',
            max: 64
        },
        {
            field: 'CATID',
            label: 'CAT ID',
            max: 49
        },
        {
            field: 'CATValue',
            label: 'CAT Value',
            max: 49
        },
        {
            field: 'SystemValue',
            label: 'System Value',
            type: 'boolean',
            width: 200
        },
        {
            field: 'ImportValue',
            label: 'Import Value',
            type: 'number',
            width: 200,
            hideInAddGrid: true
        }
    ]
});

export default Lookup;